import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import type { StylesMap } from 'Types';

const baseStyles: StylesMap = {
    container: {
        flex: 1,
        flexDirection: 'column',
        width: '100%',
        top: Device.isTabletOrWeb ? '100%' : '90%',
        justifyContent: 'flex-end',
        position: 'absolute',
        right: '100%'
    }
};

export default StyleSheet.create(baseStyles as any);

export const timelineStyle: StylesMap = {
    backgroundContainer: {
        backgroundColor: 'transparent'
    },
    progressDot: { display: 'none' },
    container: {
        marginHorizontal: 10,
        flex: 1,
        height: 3,
        flexGrow: 0
    },
    progress: {
        backgroundColor: Theme.primaryActiveColor
    }
};
